import { toastService } from "src/libraries/toast";
import { getNewsUseCase } from "./getNewsUseCase";
import { CreateNewsDto } from "../entity/news/dto/create-news-dto";
import { newsService } from "../entity/news/NewsService";

export const createNewsUseCase = async (body: CreateNewsDto) => {
    try {
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image) {
                formData.append('image', body.image, body.image.name)
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        const response = await newsService.create(formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getNewsUseCase();
        }
        return response;
    } catch (error) {
        console.warn('createNewsUseCase: ', error);
    }
}  